'use client';

import { Button } from '@ahafood/ui/components/button';
import { EmptySearch } from '@ahamove/icons/empty';
import { useStoreCitySheet } from '@/contexts/store-city-sheet-context';
import { prettifyCitySlug } from '@/lib/fast-location-utils';

interface CityNotServiceableProps {
  citySlug: string;
}

/**
 * Slug trên URL không nằm trong list city đang phục vụ.
 *
 * Cố ý trả HTTP 200 chứ không 404: city có thể chỉ tạm ngưng, và mọi link đã
 * chia sẻ / đã index sẽ chết theo nếu 404. Ở đây cho user một đường đi tiếp
 * (chọn địa chỉ → điều hướng sang city phục vụ được) thay vì bỏ mặc.
 *
 * CHỈ dùng khi list city lấy được mà không chứa slug này. Trường hợp không hỏi
 * được list (API sập) tuyệt đối không render màn này — xem `UrlCityStatus`.
 */
export default function CityNotServiceable({
  citySlug,
}: CityNotServiceableProps) {
  const { openCitySheet } = useStoreCitySheet();

  return (
    <div
      className="flex flex-col items-center justify-center px-6 py-20 text-center"
      data-testid="city-not-serviceable"
    >
      <EmptySearch className="mb-4 size-20" />
      <h1 className="text-lg font-semibold text-neutral-90">
        AhaFood chưa phục vụ {prettifyCitySlug(citySlug) || 'khu vực này'}
      </h1>
      <p className="mt-2 max-w-sm text-sm text-neutral-60">
        Khu vực này chưa có quán nào trên AhaFood. Chọn một địa chỉ giao để xem
        các quán đang phục vụ quanh bạn.
      </p>
      <Button type="button" className="mt-5" onClick={() => openCitySheet()}>
        Chọn địa chỉ
      </Button>
    </div>
  );
}
